import cn from "classnames";
import Head from "next/head";

import Editorials from "~/types/editorials";

import stylesKissesInfo from "../../cart/cart-kisses-info.module.scss";
import MediaAsset from "../../common/media-asset";
import styles from "./skeleton-cart-kisses-info.module.scss";

type Props = {
  page: Editorials.CartPage | null;
  withImage?: boolean;
};

export default function SkeletonCartKissesInfo(props: Props) {
  const { page } = props;
  return (
    <div
      className={cn(
        stylesKissesInfo.container,
        styles.container,
        props.withImage && stylesKissesInfo.withImage,
        "pulseAnimation"
      )}
    >
      <div className={cn(stylesKissesInfo.imageContainer, styles.backgroundLightGray)}></div>
      <div className={cn(stylesKissesInfo.textContainer, styles.textContainer)}>
        <p className={cn(stylesKissesInfo.text, styles.text, styles.backgroundLightGray)}></p>
        <p className={cn(stylesKissesInfo.text, styles.text, styles.backgroundLightGray)}></p>
        <p className={cn(stylesKissesInfo.text, styles.text, styles.backgroundLightGray)}></p>
      </div>
      <div style={{ display: "none" }}>
        {page?.loggedLoyaltyProgramMedia && (
          <MediaAsset entry={page.loggedLoyaltyProgramMedia} noLazy={true} sizes="500px" width={0} height={0} />
        )}
        {page?.guestLoyaltyProgramMedia && (
          <MediaAsset entry={page.guestLoyaltyProgramMedia} noLazy={true} sizes="500px" width={0} height={0} />
        )}
      </div>
    </div>
  );
}
